import { FormStore, useStoreState } from '@ariakit/react'
import { FC } from 'react'

import { ProductCatalogEmbroideryPlacement } from '../../../../../../__generated__/graphql/catalog/graphql'
import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { useEmbroidery } from '../../../../../../containers/EmbroideryContainer/EmbroideryProvider'
import {
  EmbroideryFormKind,
  IconFormValues,
} from '../../../../../../containers/EmbroideryContainer/types'
import { PlacementSelector } from '../../../../Modal/primitives/selectors/PlacementSelector/PlacementSelector'
import { IconPlacementWrapper } from '../../../../Modal/primitives/shared-form-styles'

interface Props {
  labelId: string
  iconPlacements: ProductCatalogEmbroideryPlacement[] | null | undefined
  form: FormStore<IconFormValues>
  kind: EmbroideryFormKind | null
}

export const IconPlacement: FC<Props> = ({ labelId, form, iconPlacements, kind }) => {
  const { setCurrentPlacement } = useEmbroidery()

  const {
    embroidery: {
      modal: { forms: fixtures },
    },
  } = useTranslation()

  const iconPlacement = useStoreState(form, s => s.values.iconPlacement)
  const errorMessage = useStoreState(form, () =>
    form.getFieldTouched('iconPlacement') ? form.getError('iconPlacement') : undefined
  )

  if (!iconPlacements) return null

  const handleSelectIconPlacement = (placement: ProductCatalogEmbroideryPlacement) => {
    setCurrentPlacement(kind, placement)
    form.setValue('iconPlacement', placement)
  }

  return (
    <IconPlacementWrapper>
      <PlacementSelector
        errorMessage={errorMessage ?? undefined}
        label={fixtures.iconOption.iconPlacementLabel}
        labelId={labelId}
        onSelectPlacement={handleSelectIconPlacement}
        placementOptions={iconPlacements}
        selectedPlacementOption={iconPlacement}
      />
    </IconPlacementWrapper>
  )
}
